import { TAB_TYPE_DEED, TAB_TYPE_LEASE } from '@/constants'
import { titleCase } from '@/utils'
import { MdArticle, MdAutoAwesomeMosaic } from 'react-icons/md'

const TractJoinList = ({ tract }) => {
    return (
        <ul className="flex flex-col gap-2">
            {tract.joins?.map(j => {
                
                const runsheetName = j.runsheet.name
                const tabName = j.runsheetTab ? j.runsheetTab.name : j.runsheet.name
                const isTab = !!j.runsheetTab
                
                const name = isTab ? `${runsheetName} - ${tabName} (Tab)` : runsheetName
                
                return (
                    <li key={j.id}>
                        <div className="text-xs text-slate-400 -mb-1">
                            {titleCase(j.ownershipType)}
                        </div>
                        <div className="flex items-center gap-2 tooltip" data-tip={name}>
                            {j.ownershipType === TAB_TYPE_LEASE &&
                                <MdArticle className="text-md" />}
                            {j.ownershipType === TAB_TYPE_DEED &&
                                <MdAutoAwesomeMosaic className="text-md" />}
                            <div className="truncate max-w-[200px]">
                                {runsheetName}
                            </div>
                        </div>
                        <div className="text-sm text-slate-400 -mt-1">
                            {isTab && `${tabName}`}
                        </div>
                    </li>
                )
            })}
        </ul>
    )
}

export default TractJoinList